/**
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'./Custom',
	'./Schematic',
	'./Rave2heat',
	'./Rave2bundlearea',
	'./Rave2comet',
	'./Spiral',
	'./Decisiontree',
	'./Sunburst',
	'./Rave2bundletreemap',
	'./Rave2bundlepie',
	'./Ravebubble',
	'./Rave2marimekko',
	'./Rave2bundlebullet',
	'./Ravescatter',
	'./Rave2bundlepackedbubble',
	'./Rave2bundlehierarchicalpackedbubble',
	'./Rave2point',
	'./Rave2bundlewordcloud',
	'./List',
	'./Rave2line',
	'./Rave2bundleradialbar',
	'./MultipleDialCategoryLabel',
	'./Rave2bundlecolumn',
	'./Rave2bundlestackedcolumn',
	'./Rave2bundlebar',
	'./Rave2bundlestackedbar',
	'./Rave2bundlecomposite',
	'./Rave2bundlecomposite_legacy',
	'./Rave2bundlenetwork',
	'./Rave2network',
	'./Rave2bundletiledmap',
	'./Rave2polygonmap',
	'./Rave2bundleradar',
	'./Rave2bundlewaterfall',
	'./Rave2bundleboxplot',
	'./SchematicsPreview',
	'./VisualizationPreview'
], function(
	Custom,
	Schematic,
	Rave2heat,
	Rave2bundlearea,
	Rave2comet,
	Spiral,
	Decisiontree,
	Sunburst,
	Rave2bundletreemap,
	Rave2bundlepie,
	Ravebubble,
	Rave2marimekko,
	Rave2bundlebullet,
	Ravescatter,
	Rave2bundlepackedbubble,
	Rave2bundlehierarchicalpackedbubble,
	Rave2point,
	Rave2bundlewordcloud,
	List,
	Rave2line,
	Rave2bundleradialbar,
	MultipleDialCategoryLabel,
	Rave2bundlecolumn,
	Rave2bundlestackedcolumn,
	Rave2bundlebar,
	Rave2bundlestackedbar,
	Rave2bundlecomposite,
	Rave2bundlecomposite_legacy,
	Rave2bundlenetwork,
	Rave2network,
	Rave2bundletiledmap,
	Rave2polygonmap,
	Rave2bundleradar,
	Rave2bundlewaterfall,
	Rave2bundleboxplot,
	SchematicsPreview,
	VisualizationPreview
) {
	'use strict';
	return {
		'custom': new Custom().config,
		'schematic': new Schematic().config,
		'com.ibm.vis.rave2heat':new Rave2heat().config,
		'com.ibm.vis.rave2bundlearea':new Rave2bundlearea().config,
		'com.ibm.vis.rave2comet': new Rave2comet().config,
		'com.ibm.vis.spiral': new Spiral().config,
		'com.ibm.vis.decisiontree': new Decisiontree().config,
		'com.ibm.vis.sunburst':new Sunburst().config,
		'com.ibm.vis.rave2bundletreemap': new Rave2bundletreemap().config,
		'com.ibm.vis.rave2bundlepie':new Rave2bundlepie().config,
		'com.ibm.vis.ravebubble':new Ravebubble().config,
		'com.ibm.vis.rave2marimekko':new Rave2marimekko().config,
		'com.ibm.vis.rave2bundlebullet':new Rave2bundlebullet().config,
		'com.ibm.vis.ravescatter':new Ravescatter().config,
		'com.ibm.vis.rave2bundlepackedbubble':new Rave2bundlepackedbubble().config,
		'com.ibm.vis.rave2bundlehierarchicalpackedbubble':new Rave2bundlehierarchicalpackedbubble().config,
		'com.ibm.vis.rave2point':new Rave2point().config,
		'com.ibm.vis.rave2bundlewordcloud':new Rave2bundlewordcloud().config,
		'list':new List().config,
		'com.ibm.vis.rave2line':new Rave2line().config,
		'com.ibm.vis.rave2bundleradialbar':new Rave2bundleradialbar().config,
		'multipleDialCategoryLabel': new MultipleDialCategoryLabel().config,
		'com.ibm.vis.rave2bundlecolumn':new Rave2bundlecolumn().config,
		'com.ibm.vis.rave2bundlestackedcolumn':new Rave2bundlestackedcolumn().config,
		'com.ibm.vis.rave2bundlebar':new Rave2bundlebar().config,
		'com.ibm.vis.rave2bundlestackedbar':new Rave2bundlestackedbar().config,
		'com.ibm.vis.rave2bundlecomposite': new Rave2bundlecomposite().config,
		'com.ibm.vis.rave2bundlecomposite.legacy':new Rave2bundlecomposite_legacy().config,
		'com.ibm.vis.rave2bundlenetwork': new Rave2bundlenetwork().config,
		'com.ibm.vis.rave2network': new Rave2network().config,
		'com.ibm.vis.rave2bundletiledmap': new Rave2bundletiledmap().config,
		'com.ibm.vis.rave2polygonmap': new Rave2polygonmap().config,
		'com.ibm.vis.rave2bundleradar': new Rave2bundleradar().config,
		'com.ibm.vis.rave2bundlewaterfall': new Rave2bundlewaterfall().config,
		'com.ibm.vis.rave2bundleboxplot': new Rave2bundleboxplot().config,
		'com.ibm.vis.schematicsPreview': new SchematicsPreview().config,
		'visualizationPreview': new VisualizationPreview().config
	};
});